import Vue from 'vue'
import Vuex from 'vuex'
import defaultAvatar from '@/assets/images/avatar.png'
import { tkParse } from '@moke/vue-tk'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    pageTitle: '',
    // 用户的层级信息
    hierarchy: null,
    sessionToken: null,
    auth: null, // 权限
    user: null,
    device: null,
    sidebarOpened: true,
    thisYear: 2019,
    warehouseId: null
  },
  getters: {
    nickname (state) {
      return state.user ? state.user.name ? state.user.name : state.user.username : '未登录'
    },
    avatar (state) {
      return (state.user && state.user.avatar) || defaultAvatar
    },
    isWarehouseAdmin (state) {
      return state.user && state.user.userType === 'warehouse'
    },
    isAdmin (state) {
      return state.user && state.user.isAdmin
    },
    userLevelTag (state) {
      return ((state.hierarchy && state.hierarchy.tag)) || ''
    }
  },
  mutations: {
    setPageTitle (state, pageTitle) {
      state.pageTitle = pageTitle
    },
    setSidebarOpened (state, sidebarOpened) {
      state.sidebarOpened = sidebarOpened
    },
    setDevice (state, device) {
      state.device = device
    },
    setSessionToken (state, sessionToken) {
      state.sessionToken = sessionToken
    },
    setUser (state, user) {
      state.user = user
    },
    setUserHierarchy (state, hierarchy) {
      state.hierarchy = hierarchy
    },
    setWarehouseId (state, warehouseId) {
      state.warehouseId = warehouseId
    },
    clearUser (state) {
      state.hierarchy = null
      state.sessionToken = null
      state.auth = null
      state.user = null
      state.warehouseId = null
    },
    setAuth (state, val) {
      state.auth = val
    },
    setYear (state, thisYear) {
      state.thisYear = thisYear
    },
    initFromStorage (state, opt) {
      for (let i in opt) {
        state[i] = opt[i]
      }
    }
  },
  actions: {
    async initUser ({ commit, state, dispatch }, user) {
      const userinfo = await getUserInfo(user.objectId)
      if (userinfo.status === 'disabled') {
        Vue.prototype.$notification['error']({
          message: '无法登录',
          description: '此账号已被禁用'
        })
        throw new Error('disabled')
      }
      let hierarchy
      let permissions = []
      // 如果用户有层级，不是超级管理员
      if (userinfo.isAdmin) {
        hierarchy = ''
        Vue.prototype.setUserAllPermissions()
      } else {
        hierarchy = await getUserLevelInfo(userinfo.hierarchy)
        permissions = hierarchy.permissions || []
        Vue.prototype.setUserPermissions(permissions)
      }
      commit('setUser', userinfo)
      commit('setSessionToken', user.sessionToken)
      commit('setUserHierarchy', hierarchy)
    }
  }
})
// 获取用户的层级信息
async function getUserLevelInfo (hierarchy) {
  const res = await tkParse.get(`/classes/hierarchy/${hierarchy}`)
  return res.data
}

async function getUserInfo (objectId) {
  const res = await tkParse.get(`/classes/_User/${objectId}`)
  return res.data
}

export default store
